export function IconCode() {
    return <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={25}
        fill="none"
    >
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="m16 18.5 6-6-6-6M8 6.5l-6 6 6 6"
        />
    </svg>;
}
